import MainContent from "./main-content";
import LoginContainer from "../login/login-container";

function Layout() {
  return (
    <LoginContainer>
      <div className="body-container rtl">
        <MainContent />
      </div>
    </LoginContainer>
  );
}

export default Layout;
